module.exports = __webpack_public_path__ + "img/Battle2.6de0d6ef.jpg";